var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6156 3.76691L9.54888 2.16691C9.28222 1.90024 8.68222 1.76691 8.28222 1.76691H5.74888C4.94888 1.76691 4.08222 2.36691 3.88222 3.16691L2.28222 8.03357C1.94888 8.96691 2.54889 9.76691 3.54889 9.76691H6.21555C6.61555 9.76691 6.94889 10.1002 6.88222 10.5669L6.54889 12.7002C6.41555 13.3002 6.81555 13.9669 7.41555 14.1669C7.94889 14.3669 8.61555 14.1002 8.88222 13.7002L11.6156 9.63357",
    stroke: "#64778E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0156 3.76691V10.3002C15.0156 11.2336 14.6156 11.5669 13.6822 11.5669H13.0156C12.0822 11.5669 11.6822 11.2336 11.6822 10.3002V3.76691C11.6822 2.83358 12.0822 2.50024 13.0156 2.50024H13.6822C14.6156 2.50024 15.0156 2.83358 15.0156 3.76691Z",
    stroke: "#64778E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.307d5c0c61199fc17bcfd36efe50a81d.svg";
export { ForwardRef as ReactComponent };